import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Page, Loading, Ooops } from 'components';
import { Header, Results, SearchBar, Total } from './components';
import {
  AuthCheckJWT,
  GetCompany,
  GetBranch,
  GetQrFilter,
  GetDeviceFilter,
  GetMockCharge,
  GetCharge
} from 'store/actions';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';

const Charge = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const authen = useSelector(({ authen }) => authen);
  const charge = useSelector(({ charge }) => charge);
  const chargeData = useSelector(({ charge }) => charge.data);

  const [pageInit, setPageInit] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    dispatch(AuthCheckJWT('/charge'));
  }, [dispatch]);

  useEffect(() => {
    const superFetchData = async () => {
      await dispatch(GetCompany());
      await dispatch(GetBranch());
      await dispatch(GetDeviceFilter());
      await dispatch(GetQrFilter());
      // await dispatch(GetMockCharge());
      await dispatch(GetCharge());
      setPageInit(true);
    };

    const adminFetchData2 = async () => {
      await dispatch(GetBranch());
      await dispatch(GetDeviceFilter());
      await dispatch(GetQrFilter());
      // await dispatch(GetMockCharge());
      await dispatch(GetCharge());
      setPageInit(true);
    };

    if (authen.isAuthenticated) {
      if (authen.loginUser.role === 'super') {
        superFetchData();
      } else {
        adminFetchData2();
      }
    }
  }, [dispatch, authen]);

  useEffect(() => {
    if (chargeData) {
      setTableData(
        searchText.length === 0
          ? chargeData.data
          : filterArrayByKeyword(chargeData.data, searchText)
      );
    }
  }, [chargeData, searchText]);

  const filterArrayByKeyword = (data, keyword) => {
    if (keyword === '') return data;

    return _.filter(
      data,
      record =>
        record.amount
          .toString()
          .toUpperCase()
          .includes(searchText.toUpperCase()) ||
                record.type.toUpperCase().includes(searchText.toUpperCase()) ||
                record.invoiceId.toUpperCase().includes(searchText.toUpperCase()) ||
                record.device.toUpperCase().includes(searchText.toUpperCase()) ||
                record.created.toUpperCase().includes(searchText.toUpperCase())
    );
  };

  if (charge.isFetching) {
    return <Loading title="Charge" />;
  }

  if (charge.isError) {
    return <Ooops title="Dashboard" />;
  }

  return (
    <Page
      className={classes.root}
      title="Charge"
    >
      <Header />
      {chargeData && (
                <>
                    <Grid
                      className={classes.container}
                      container
                      spacing={3}
                    >
                      <Grid
                        item
                        lg={12}
                        xs={12}
                      >
                        <Total />
                      </Grid>
                    </Grid>
                    <SearchBar
                      onSearch={setSearchText}
                      searchValue={searchText}
                    />
                    <Results
                      charge={tableData}
                      className={classes.results}
                    />
                </>
      )}
    </Page>
  );
};

export default Charge;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  },
  container: {
    marginTop: theme.spacing(0)
  }
}));
